/**
 * Logs performance metric to console in development
 */
export function logMetric(_category: string, _metric: Record<string, unknown>): void {
  if (process.env.NODE_ENV === "development") {
    // Console logging removed as per original file or you can add it back if needed
    // The original file had an empty body in logMetric
  }
}
